// import React from "react";
// import { Card, Col, Row } from "react-bootstrap";
// import Logo from "components/common/Logo";
// import Section from "components/common/Section";
// import { Outlet } from "react-router-dom";
// import bg from "../assets/img/myImages/bg.jpg";
// import logo from "assets/img/logos/logoNew.png";
// const AuthSimpleLayout = () => {
//   return (
//     <Section
//       className="py-0"
//       style={{ backgroundImage: `url(${bg})`, backgroundSize: "cover" }}
//     >
//       <Row className="flex-center min-vh-100 py-6">
//         <Col sm={10} md={8} lg={6} xl={5} style={{ width: "395px" }}>
//           <Card
//             style={{
//               borderRadius: "5px",
//               boxShadow: "0px 4px 23px rgba(0, 0, 0, 0.14)",
//             }}
//             className="border"
//           >
//             <div className="d-flex justify-content-center mt-2">
//               <img
//                 src={logo}
//                 alt="Logo"
//                 width={50}
//                 style={{ marginLeft: "2px" }}
//               />
//             </div>
//             <Card.Body className="p-4 p-sm-4">
//               <Outlet />
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>
//     </Section>
//   );
// };

// export default AuthSimpleLayout;


import { LOGINBG, LOGO } from "assets/seller-assets";
import FooterStandard from "components/pages/landing/FooterStandard";
import NavbarStandard from "components/pages/landing/NavbarStandard";
import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Outlet } from "react-router-dom";

const AuthSimpleLayout = () => {
  return (
    <>

      <section
        style={{
          backgroundImage: `url(${LOGINBG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <NavbarStandard />
        <div className="container">
          <Row className="align-items-center justify-content-between">
            {/* 🧡 Left Side — Branding / Info */}
            <Col
              lg={6}
              className="text-white text-center text-lg-start mb-5 mb-lg-0"
            >

            </Col>

            {/* 🤍 Right Side — Form Card */}
            <Col lg={4} md={8} sm={10} >
              <Card
                className="border-0 shadow"
                style={{
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                }}
              >
                <div className="d-flex justify-content-center mt-3">
                  <img src={LOGO} alt="Logo" width={150} />
                </div>

                <Card.Body className="p-4">
                  <Outlet />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </section>
      <FooterStandard />
    </>
  );
};

export default AuthSimpleLayout;
